import { BaseRequest } from './BaseRequest';

export class TicketRequest extends BaseRequest {
    Filter: string | null;
    Ticket: {
        Id : string,
        Status : string
    } | null;
}